<template>
  <!--  page starting div -->
   <div>
    <RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
  <div v-else-if="is_no_records == 1">
    <GlobalEmptyRecord RouteName="CustomerAdvanceCreate">
      <template slot="title">
        <h2>Time for Advance Payment!!!</h2>
      </template>
      <template slot="content">
        <span style="color:gray">The payment of today is the savings for tomorrow</span>
      </template>
      <template slot="page">New Customer Advance</template>
    </GlobalEmptyRecord>
  </div>
  <div class="start-page" v-else style="margin-top:-10px !important">
    <!-- section 1: theader row to declare page headign and to call create page button -->
    <template v-if="CheckedCount == 0">
      <b-row class="px-pad border-bottom" style="height:42px">
        <b-col cols="8" class="px-0">
          <b-dropdown
            variant="link"
            size="sm"
            class="index-filter-heading"
            dropdown
            toggle-class="text-decoration-none"
            :text="filter_name"
          >
            <div class="dropdownitem-list">
              <b-dropdown-item
                :class="{'filter_dropdown' : true}"
                :to="{ name : 'CustomerAdvance',query: {page: 1 ,show: 10,search:'',status:item.status_id,sort:sort,label:label,custom:custom } }"
                v-for="item in filter_list"
                :key="item.status_id"
                v-if="item.status_name != filter_name"
              >{{ item.status_name }}</b-dropdown-item>
            </div>

            <b-dropdown-divider v-if="filter_list.length>1" />
            <router-link
              class="event-link dropdown-item"
              :to="{ name : 'FilterCreate',params : {title :'Customer Advance',module:'payment',call:'fetchPaymentmethod',type:'customer_advance',route:'customeradvance'}}"
            >Add Custom Filter</router-link>
          </b-dropdown>
          <router-link
            class="event-link"
            v-if="status >= 100"
            :to="{ name : 'FilterUpdate',params : {id:getPresentValue(filter_list,'status_name',filter_name),title :'Customer Advance',module:'payment',call:'fetchPaymentmethod',type:'customer_advance',route:'customeradvance'}}"
          >
            <b-button size="xs" style="position:relative;bottom:4px;" variant="light">
              <i class="la la-edit la-lg"></i>
            </b-button>
          </router-link>
        </b-col>
        <b-col cols="4" class="text-right px-0">
          <router-link
            :to="{ name : 'CustomerAdvanceCreate'}"
            v-if="RoutePermission(false,'','','paymentsreceived','create')"
          >
            <b-button variant="primary" size="sm" class="mr-2">New Customer Advance</b-button>
          </router-link>
           <b-button variant="light" size="sm" class="mr-2" @click="getrefreshList()"> <i class="la la-refresh la-lg"></i></b-button>
          <b-dropdown variant="light" size="sm" class="no-caret-dropdown">
            <template slot="button-content">
              <i class="la la-navicon la-lg"></i>
            </template>
            <template v-if="RoutePermission(false,'','','settings','export')">
              <b-dropdown-item @click="exportModal()">
                <span class="no_caret_import la la-download mr-3"></span>Export CustomerAdvance
              </b-dropdown-item>
              <b-dropdown-divider />
            </template>
            <p class="fw-semi-bold theme-text-color ml-3">Add Columns</p>
            <div class="dropdownitem-block">
              <li class="ml-3">
                <b-form-checkbox
                  name="place_of_supply"
                  v-model="place_of_supply"
                  value="1"
                >Place of Supply</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox name="ref_no" v-model="ref_no" value="1">Reference No</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox name="refund_amount" v-model="cus_adv_no" value="5">Advance</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="refund_amount"
                  v-model="refund_amount"
                  value="2"
                >Refund amount</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox name="used_amount" v-model="used_amount" value="4">Used Amount</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2 ">
                <b-form-checkbox name="created_at" v-model="created_at" value="5">Created Time</b-form-checkbox>
              </li>
                <li class="ml-3 pt-2 pb-2">
                <b-form-checkbox name="updated_at" v-model="updated_at" value="6">Updated Time</b-form-checkbox>
              </li>
            </div>
          </b-dropdown>
        </b-col>
      </b-row>
    </template>
    <!-- section 2: to show the search criteria detail  -->
    <b-row>
      <b-col cols="12" class="px-0">
        <!--  section 4:show the list of table data form api -->
        <b-row style="height:42px" class="px-pad border-bottom" v-if="CheckedCount > 0">
          <b-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6" class="px-pad">
            <!-- <b-button variant="light" class="text-left mr-2">Bulk Update</b-button> -->
            <!--  delete the selected invoice -->
            <b-button
              size="sm"
              variant="light"
              class="text-left"
              @click="deletemodal"
              :disabled="!RoutePermission(false,'','invoice','paymentsreceived','delete')"
            >
              <i
                class="glyphicon glyphicon-trash"
                v-b-tooltip="!RoutePermission(false,'','invoice','paymentsreceived','delete')?' You do not have permission to perform this operation. Please contact your Administrator. ':''"
              ></i>
            </b-button>
          </b-col>
          <b-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6" class="px-pad">
            <i
              v-on:click="checkAll({
              target :{
                checked : false
              }
            }),CheckedCount = 0,checkboxes1[0] = false"
              class="la la-times-circle-o la-lg cursor_pointer float-right mar-top-close"
            ></i>
          </b-col>
        </b-row>
        <!-- search criteria alert -->
        <b-alert
          class="alert-transparent alert-shade mx-mar mt-3"
          :show="this.$route.params.search == '' ? false : true"
        >
          <router-link
            class="text-dark float-right"
            :to="{ name : 'CustomerAdvance',query: {page: page ,show: count,search:'',sort:sort,label:label,custom:custom } }"
          >
            <i class="la la-remove la-lg text-decoration-none"></i>
          </router-link>
          <p>
            <span
              class="fw-semi-bold"
            >Customer Name / Customer ID / Company name / Payment No / Reference no:</span>
            {{ this.$route.query.search }}
          </p>
        </b-alert>

        <div
          :class="this.$route.params.search=='' ?'table-responsive':'table_search'"
          id="scrollCol"
        >
          <table class="table table-hover index-table">
            <thead>
              <tr>
                <th style="width:54px !important">
                  <div class="abc-checkbox index-checkbox text-left">
                    <input
                      type="checkbox"
                      id="checkboxall"
                      v-model="checkboxes1[0]"
                      @change="event => checkAll(event)"
                    />
                    <label for="checkboxall" />
                  </div>
                </th>

                <th style="min-width:140px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'CustomerAdvance',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'pymnt_date',custom:custom } }"
                  >
                    Date
                    <small class="text-muted" v-if="label == 'pymnt_date'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:140px !important" v-if="cus_adv_no==5">Advance</th>
                <th style="min-width:135px !important" v-if="ref_no==1">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'CustomerAdvance',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'ref_no',custom:custom } }"
                  >
                    Ref No.
                    <small class="text-muted" v-if="label == 'ref_no'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:180px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'CustomerAdvance',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'cus_name',custom:custom } }"
                  >
                    Customer
                    <small class="text-muted" v-if="label == 'cus_name'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:200px !important" v-if="place_of_supply==1">Place of Supply</th>
                <th style="min-width:150px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'CustomerAdvance',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'method_name',custom:custom } }"
                  >
                    Mode
                    <small class="text-muted" v-if="label == 'method_name'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>

                <th class="text-right" style="min-width:140px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'CustomerAdvance',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'pymnt_amount',custom:custom } }"
                  >
                    Amount
                    <small class="text-muted" v-if="label == 'pymnt_amount'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th
                  class="text-right"
                  style="min-width:140px !important"
                  v-if="refund_amount==2"
                >Refund Amt.</th>
                <th
                  class="text-right"
                  style="min-width:140px !important"
                  v-if="used_amount==4"
                >Used Amt.</th>
                <th class="text-right" style="min-width:140px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'CustomerAdvance',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'excess_amount',custom:custom } }"
                  >
                    Unused
                    <small class="text-muted" v-if="label == 'excess_amount'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                     <th  style="min-width:300px !important" v-if="created_at">
                   <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'CustomerAdvance',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'created_at',custom:custom } }"
                  >
                    Created Time
                    <small class="text-muted" v-if="label == 'created_at'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                   <th  style="min-width:300px !important" v-if="updated_at" >
                 <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'CustomerAdvance',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'updated_at',custom:custom } }"
                  >
                    Updated Time
                    <small class="text-muted" v-if="label == 'updated_at'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th class="text-right" style="width:30px !important"></th>
              </tr>
            </thead>
            <tbody>
              <template v-if="lists.length == 0">
                <tr>
                  <td colspan="10" class="text-center">No data to display</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(list,index) in lists" :key="list.pymnt_hdr_id">
                  <td>
                    <div class="abc-checkbox index-checkbox text-left">
                      <input
                        type="checkbox"
                        v-model="checkboxes1[index + 1]"
                        :id="'checkbox'+(index+1)"
                        :true-value="list.pymnt_hdr_id"
                        :value="list.pymnt_hdr_id"
                        @change="event => changeCheck(event, 'checkboxes1', index+1)"
                      />
                      <label :for="'checkbox'+(index+1)" />
                    </div>
                  </td>

                  <td>{{getDateFormat(list.pymnt_date)}}</td>
                  <td v-if="cus_adv_no==5" class="text-nowrap">{{ list.cus_adv_no}}</td>
                  <td v-if="ref_no==1" class="text-nowrap">{{ list.ref_no}}</td>
                  <td
                    style="max-width:180px !important"
                    v-if="RoutePermission(false,'','','paymentsreceived','index')"
                  >
                    <router-link
                      class="event-link"
                      :to="{ name : 'CustomerAdvanceView',params:{id:list.pymnt_hdr_id}}"
                    >
                      <span class="text theme-text-color">{{ list.cus_name }}</span>
                    </router-link>
                  </td>
                  <td style="max-width:180px !important" v-else>
                    <span class="text theme-text-color">{{ list.cus_name }}</span>
                  </td>
                  <td
                    v-if="place_of_supply==1"
                  >{{ getDetails($AppDetails.state_details,list.place_of_supply,'state_name')}}</td>
                  <td>{{ list.method_name }}</td>

                  <td class="text-right">
                    {{ getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+parseFloat(list.received_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>

                  <td v-if="refund_amount==2" class="text-right">
                    {{getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+ " "+parseFloat(list.refund_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>
                  <td v-if="used_amount==4" class="text-right">
                    {{ getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+parseFloat(list.used_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>
                  <td class="text-right">
                    {{ getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+parseFloat(list.excess_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>
                    <td v-if="created_at">
                      <span class="text">
                      {{ displayDateTime(list.created_at) }}
                      </span>
                  </td>
                    <td v-if="updated_at" >
                         <span class="text">
                      {{ displayDateTime(list.updated_at) }}
                         </span>
                  </td>
                  <td class="text-right">
                    <router-link
                      v-if="RoutePermission(false,'','invoice','paymentsreceived','update')"
                      class="event-link theme-text-color text-decoration-none"
                      :to="{ name : 'CustomerAdvanceUpdate',params:{id:list.pymnt_hdr_id}}"
                    >
                      <i class="la la-edit la-lg table-hover-visible"></i>
                    </router-link>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
    <b-row
      v-if="lists.length > 0"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="8" class="mt-2 pt-1 px-0">
        <nav class="float-left">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
            of {{ total_count }} entries
            <span>
              <b-dropdown
                variant="link"
                size="xs"
                toggle-class="text-decoration-none"
                :show="false"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'CustomerAdvance',query: {page: 1,show: 10,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'CustomerAdvance',query: {page: 1,show: 25,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'CustomerAdvance',query: {page: 1 ,show: 50,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>
      <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
        <div v-if="arrow">
          <a @click="left('#scrollCol')" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
          </a>
          <a @click="right('#scrollCol')">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
          </a>
        </div>
      </b-col>
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
        <template v-if="show<total_count">
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'CustomerAdvance',query: {page: page - 1 ,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'CustomerAdvance',query: {page: 1 ,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                >First</router-link>
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'CustomerAdvance',query: {page: page - 1 ,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  >Previous</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'CustomerAdvance',query: {page: page + 1,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom  } }"
                  >Next</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'CustomerAdvance',query: {page: Math.ceil(total_count / count),show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom  } }"
                >Last</router-link>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'CustomerAdvance',query: {page: page + 1,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom  } }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
      </b-col>
    </b-row>
    <!--  bulk delete modal -->
    <DeleteRecord
      v-on:setDelete="getDelete"
      :value="value"
      module="customeradvance"
      content="The selected customeradvance(s) will be deleted and cannot be retrieved later. Are you sure about deleting them?"
    ></DeleteRecord>
    <LogRecord :message="logrecords"></LogRecord>
    <!-- <b-modal
      id="CustomerAdvanceUpdate"
      size="md"
      body-class="bg-white"
      cancel-title="cancel"
      cancel-variant="light"
      ok-title="Update"
      title="Bulk Update-Customer Advance"
    >
      <p>Choose a field from the dropdown and update with new information.</p>
      <b-row>
        <b-col>
          <b-form-group>
            <select
              name="mode]"
              class="form-control text-right"
              style="padding:2px;background: #f7f7f7;"
            >
              <option value="0"></option>
              <option value="1">Payment Mode</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <select
              name="bank"
              class="form-control text-right"
              style="padding:2px;background: #f7f7f7;"
            >
              <option value="0"></option>
              <option value="1">Bank Remittance</option>
              <option value="1">Bank Transfer</option>
              <option value="2">Cash</option>
              <option value="3">Check</option>
              <option value="4">Credit card</option>
            </select>
          </b-form-group>
        </b-col>
      </b-row>
      <span>Note: All the selected invoices will be updated with new information and you cannot undo this.</span>
    </b-modal>-->
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Customer Advance'"
      @downloaded="export_modal=false"
    />
  </div>
   </div>
</template>
<script>
import { mapState } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";
import vSelect from "vue-select"; // searchable select dropdwon
import DeleteRecord from "@/components/Modal/DeleteModal"; // modal for deleting created credit used record
import LogRecord from "@/components/Modal/ErrorList"; // modal for deleting created credit used record
import RecordNotFound from "@/pages/Error/RecordNotFound";
import $ from "jquery";
import { formatDate } from "@/mixins/formatDate"; // to formatdate in y-m-d
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll
function getPageCustomerAdvance(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const search = routeTo.query.search || "";
  const status = routeTo.query.status || store.state.customeradvance.index_status || "";
  const label = routeTo.query.label || "";
  const sort = routeTo.query.sort || "";
  const custom = routeTo.query.custom || "";
  store
    .dispatch("customeradvance/fetchLists", {
      page: currentPage,
      show: show,
      search: search,
      status: status,
      sort: sort,
      label: label,
      custom: custom
    })
    .then(response => {
      if (search != "" && response.status == 201) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: "danger",
          showCloseButton: true
        });
      }
         else {
        store.dispatch("payment/fetchPaymentmethod");
      }
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.search = search;
      routeTo.params.status = status;
      routeTo.params.label = label;
      routeTo.params.sort = sort;
      routeTo.params.custom = custom;
      next();
    });
}
export default {
  mixins: [notificationMixin, scrollTable,formatDate],
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    search: [String, Number],
    status: [String, Number],
    label: [String, Number],
    sort: [String, Number],
    custom: [String, Number]
  },
  name: "CustomerAdvance",
  components: {
    DeleteRecord,
    LogRecord,
    RecordNotFound
  },
  data() {
    return {
      arrow: false,
      export_data: [],
      export_modal: false,
      export_xl: {
        Advance: "pymnt_no",
        Date: "pymnt_date",
        Number: "ref_no",
        Customer: "cus_name",
        Mode: "method_name",
        "Amount(BCY)": "received_amount",
        "Amount(FCY)": "export_received_amount",
        "Refund Amount(BCY)": "refund_amount",
        "Refund Amount(FCY)": "export_refund_amount",
        "Used Amount(BCY)": "used_amount",
        "Used Amount(FCY)": "export_used_amount",
        "Unused Amount(BCY)": "excess_amount",
        "Unused Amount(FCY)": "export_excess_amount",
        "Created time":"created_at",
        "Updated Time":"updated_at"
      },
      place_of_supply: "",
      refund_amount: "",
      cus_adv_no: "",
      ref_no: "",
      used_amount: "",
      logrecords: "", // to show log of popup funcitons
      value: [],
      created_at:"",
      updated_at:"",
      modalPage: "",
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      showDismissibleAlert: this.$route.query.search == "" ? false : true,
      total: 10,
      checkboxes1: [],
      CheckedCount: 0,
      vSelect
    };
  },
  updated() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },

  methods: {
        //refresh List
    getrefreshList(){
    var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
       const custom = this.$route.query.custom || "";
      const update_status = update == true ? false : true;
       store
    .dispatch("customeradvance/fetchLists", {
      page: currentPage,
      show: show,
      search: search,
      status: status,
      sort: sort,
      label: label,
      custom: custom
    })
        .then(()=>{
          this.$router.push({
            name: this.$route.name,
            query: {
              page: currentPage,
              show: show,
              search: search,
              status: status,
              sort: sort,
              label: label,
              update: update_status
            }
          })
        });
    },
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const response = await store
        .dispatch("customeradvance/fetchexportLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom
        })
        .then(() => {
          if(this.status_code!=200){
             window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.status_type,
            showCloseButton: true,
          });
          }else{
           if(this.status_code!=200){
             window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.status_type,
            showCloseButton: true,
          });
          }else{
            this.$root.$emit("bv::show::modal", "exportdata");
          return this.export;
          }
          }
        });
      return response;
    },

    //  detelted record details
    getDelete() {
      const currentPage = 1;
      const show = 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const update_status = update == true ? false : true;

      this.$router.push({
        name: this.$route.name,
        query: {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          update: update_status,
          sort: sort,
          label: label
        }
      });

      if (this.status_code == 200) {
          this.logrecords =
            this.message.message.length == 0
              ? this.message.success
              : this.message.message;
          this.$root.$emit("bv::show::modal", "loglist");
        } else {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message.message,
            type: this.message.type,
            showCloseButton: true,
          });
        }

    },
    //  call delete modal
    deletemodal() {
      var ids = this.checkboxes1;
      ids = ids.filter(item => item !== false && item !== true);
      this.value = ids;
      this.$root.$emit("bv::show::modal", "invoicedelete");
    },
    // to filter the json data - to get any particular data from json
    getPresentValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i]["filter_id"];
          break;
        }
      }
      return hasMatch;
    },
    checkAll(ev) {
      this.check_index = [];
      var fields = this;

      fields.lists.map(function(value, index) {
        fields.checkboxes1[index + 1] =
          ev.target.checked == true ? value.pymnt_hdr_id : false;
      });

      this.CheckedCount =
        ev.target.checked == true
          ? (this.page - 1) * this.show + this.lists.length
          : 0;
    },
    //select the checkbox//
    changeCheck(ev, checkbox, id) {
      var pymnt_hdr_ids = this.checkboxes1;
      pymnt_hdr_ids = pymnt_hdr_ids.filter(item => item !== false);
      // check all if page length matches
      if (pymnt_hdr_ids.length == this.lists.length) {
        this[checkbox][0] = true;
      }
      // uncheck if any of the checkbox is unchecked
      if (!ev.target.checked) {
        this[checkbox][0] = false;
      }
      if (this[checkbox][id] != false) {
        this.CheckedCount = parseInt(this.CheckedCount) + 1;
      } else {
        this.CheckedCount = parseInt(this.CheckedCount) - 1;
      }
    }
  },

  created() {
    var check = [false];
    var i;
    for (i = 0; i < this.total; i++) {
      check.push(false);
    }
    this.checkboxes1 = check;
    this.CheckedCount = 0;
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
    //
    // this.initializationMessengerCode();
    // Messenger.options = {
    //   extraClasses: this.locationClasses,
    //   theme: "air"
    // };
  },

  beforeRouteEnter(routeTo, routeFrom, next) {
       store.state.customeradvance.index_status=store.state.settings.status_code!=404? store.state.customeradvance.index_status:""
    store.dispatch(
      "payment/fetchPaymentmethod",
      JSON.stringify({
        type: "customer_advance",
        page: "filterdetails"
      })
    );
    getPageCustomerAdvance(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
        store.state.customeradvance.index_status = "";
    getPageCustomerAdvance(routeTo, next);
    this.CheckedCount = 0;
    this.checkboxes1 = [];
    this.check_index = [];
  },
  beforeRouteLeave(to, from, next) {
    store.state.customeradvance.customeradvance_index_history = from.fullPath;
    store.state.customeradvance.index_status = from.params.status;
    store.state.settings.status_code=''
    next();
  },

  computed: {
    ...mapState({
      lists: state => state.customeradvance.lists,
      total_count: state => state.customeradvance.total_count,
      count: state => state.customeradvance.count,
      search_criteria: state => state.customeradvance.search_criteria,
      is_no_records: state => state.customeradvance.is_no_records, // to check for an record in the database
      filter_list: state => state.customeradvance.filter_list, // to show the  dropdown of filter list name inside the table file: customeradvance.js
      filter_name: state => state.customeradvance.filter_name, // to show the  name of the selected filter list name inside the table file: customeradvance.js\
      message: state => state.customeradvance.log_details,
      export: state => state.customeradvance.export,
      status_code: state => state.customeradvance.status_code, 
      status_message: state => state.customeradvance.status_message, 
      status_type: state => state.customeradvance.status_type,
    })
  }
};
</script>